import type { Address } from "../order.js";

/**
 * Vorher → Nachher einer Lieferadresse – einheitlich für jede Adressänderung (Grundbereinigung, DHL-Leitdaten,
 * Logiful, Endkunde, Kunde im Portal, neu aus dem Kanal). Landet als `changes` im Verlauf und als Text in der Meldung.
 */
export const ADDRESS_FIELDS = ["company", "firstName", "lastName", "street", "houseNumber", "addition", "zip", "city", "state", "country"] as const;
export type AddressField = (typeof ADDRESS_FIELDS)[number];

export const ADDRESS_FIELD_LABEL: Record<AddressField, string> = {
  company: "Firma",
  firstName: "Vorname",
  lastName: "Nachname",
  street: "Straße",
  houseNumber: "Hausnummer",
  addition: "Zusatz",
  zip: "PLZ",
  city: "Ort",
  state: "Region",
  country: "Land",
};

/** Verlaufseinträge, die eine Lieferadresse geändert (oder bestätigt) haben – für die Anzeige im Auftrag */
export const ADDRESS_AUDIT_ACTIONS = ["order.address_normalized", "order.address_corrected", "order.address_fixed", "order.address_customer", "order.address_edited", "order.address_refetched"] as const;

const norm = (v: unknown) => String(v ?? "").trim();

export function addressDiff(from: Partial<Address> | null | undefined, to: Partial<Address> | null | undefined): Record<string, { from: string; to: string }> {
  const out: Record<string, { from: string; to: string }> = {};
  for (const f of ADDRESS_FIELDS) {
    const a = norm(from?.[f]);
    const b = norm(to?.[f]);
    if (a !== b) out[f] = { from: a, to: b };
  }
  return out;
}

/** "Straße „Eickendorfer Straße“ → „Eickendorfer Straße 10“, Zusatz „10“ → leer" */
export function addressDiffText(diff: Record<string, { from: string; to: string }>): string {
  return Object.entries(diff)
    .map(([f, c]) => `${ADDRESS_FIELD_LABEL[f as AddressField] ?? f} ${c.from ? `„${c.from}“` : "leer"} → ${c.to ? `„${c.to}“` : "leer"}`)
    .join(", ");
}
